import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import { Role } from '@data/models/role.model';
import { Acl } from '@data/models/authorization.model';

@Component({

    selector: 'syn-roles-details-dialog',
    templateUrl: 'roles-details-dialog.component.html',
    styleUrls: ['roles-details-dialog.component.scss']
})
export class RolesDetailsDialogComponent {

    public displayedColumns = ['id', 'READ', 'EDIT', 'ADMIN'];
    public dataSource: MatTableDataSource<Role>;
    public dataCount = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { roles: Role[] }
    ) {
        const globalRoles = data.roles;

        this.dataSource = new MatTableDataSource(globalRoles);
        this.dataCount = globalRoles.length;
    }

    aclList(acl: Acl[], level: string): string[] {
        const filter = _.filter(acl, item => item.level === level);
        const filteredAcls = _.transform(filter, (accu, item) => accu.push(item.entity), []);
        return filteredAcls;
    }

}
